module.exports = __webpack_public_path__ + "img/menu-sport.e31228dc.png";